import { useQuery } from '@tanstack/react-query'

import { useCurrentUser } from '@/api/auth/queries/useCurrentUser'

import { QUERY_KEYS } from '../../../lib/queryKeys'
import { getUserPkgs } from '../userPkgService'

export const useUserPkgs = () => {
  const { data: loggedUser } = useCurrentUser()
  return useQuery({
    queryKey: [QUERY_KEYS.USER_PACKAGES],
    queryFn: getUserPkgs,
    enabled: !!loggedUser?.Username,
  })
}
